<template>
  <div
    ref="tmCalendarRowElement"
    class="tm-calendar-row"
  >
    <slot />
  </div>
</template>
<script setup lang="ts">
import { ref } from '@/composition/vue/compositionApi'
import TmLogicError from '@/core/error/tmLogicError'

const tmCalendarRowElement = ref<HTMLDivElement>()

const getRootElement = () => {
  if (!tmCalendarRowElement.value) {
    throw new TmLogicError('tmCalendarRowElement not found')
  }
  return tmCalendarRowElement.value
}

defineExpose({
  getRootElement,
})
</script>

<style lang="scss" scoped>
$calendar-border: 1px solid $gray2;

.tm-calendar-row {
  display: flex;

  & > :deep(*) {
    border-bottom: $calendar-border;

    &:not(:last-child) {
      border-right: $calendar-border;
    }
  }
}
</style>
